import React, { useEffect, useRef } from 'react'
import { Box, RadioButtons } from '@labrav/react-components'
import { Typography } from '@mui/material'
import { useStyles } from './Renewal.styles'
import { KeyValue } from '../../../modules/privateOffer/privateOfferCreation/types'
import { ChannelType } from '../../../modules/privateOffer/types'
import { channelTypes, renewalOptions } from './utils'

export type OfferedTypes = 'offer' | 'resale authorization'
export type RenewalProps = {
  handleDetailsChange: (data: KeyValue) => void
  renewal: boolean
  channel: ChannelType | null
  offerType: OfferedTypes
}

export const Renewal = React.memo(
  ({ handleDetailsChange, renewal, channel, offerType }: RenewalProps) => {
    const { classes } = useStyles()

    const hasRenewedChanged = useRef(false)
    useEffect(() => {
      if (hasRenewedChanged.current) {
        handleDetailsChange({ key: 'renewalChannel', value: null })
      }
    }, [renewal])
    const handleUpdate =
      (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        if (key === 'renewal') {
          const isRenewable = event.target.value === 'Yes'
          handleDetailsChange({ key, value: isRenewable })
          hasRenewedChanged.current = true
        } else {
          handleDetailsChange({ key, value: event.target.value })
        }
      }
    return (
      <Box heading={'Renewal'} subHeading={''}>
        <div>
          <Typography className={classes.selectionHeading}>
            {`Is this ${offerType} intended to renew an existing paid subscription with an existing customer for the same underlying product?`}
          </Typography>
          <RadioButtons
            checkedValue={{
              key: renewal ? 'Yes' : 'No',
              value: renewal ? 'Yes' : 'No',
            }}
            handleChange={handleUpdate('renewal')}
            radioButtonMappings={renewalOptions}
          />
          {renewal ? (
            <>
              <div className={classes.subHeadingContainer}>
                <Typography
                  className={classes.subHeading}
                  data-testid="renewal-type-subheading"
                >
                  Renewal Type
                </Typography>
              </div>
              <RadioButtons
                checkedValue={{ key: 'channel', value: channel || '' }}
                handleChange={handleUpdate('renewalChannel')}
                radioButtonMappings={channelTypes}
              />
              {offerType === 'resale authorization' ? (
                <Typography className={classes.selectionHeading}>
                  Note: Please add buyer account ID if the customer is renewing.
                </Typography>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}
        </div>
      </Box>
    )
  }
)
